export const environment = {
    production: false,
    apiBaseUrl: 'https://api-dev.sunturqoriwasi.com/api',
    enableLogging: true
};
